import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Spinner } from "react-bootstrap";

/*
  PrivateRoute 组件用于保护需要用户认证才能访问的路由。
  当认证状态正在加载时显示加载动画，
  当用户已登录时渲染嵌套路由组件 (Outlet)，
  否则重定向到登录页面。
*/
const PrivateRoute = ( {children} ) => {
  // 从认证上下文中获取当前用户信息和加载状态
  const { currentUser, loading } = useAuth();

  // 如果正在加载认证状态，则显示加载中的动画
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  // 如果用户已登录，则渲染嵌套路由组件，否则重定向至 /login
  return currentUser ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;